import { urlConfig } from "../../config/urlConfig";
import { postCall } from "../httpService";

const DisplayProcessStageItem = urlConfig.DisplayProcessStageItem;
const GetAccount = urlConfig.GetAccount;

export const getProcessStagesData = async (params: any) => {
  try {
    const response = await postCall(DisplayProcessStageItem, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const getAccountData = async (params: any) => {
  try {
    const response = await postCall(GetAccount, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const processStageStatusChange = async (params: any) => {
  try {
    const response = await postCall(urlConfig.ProcessStageStatusChange, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const processStageInsertUpdate = async (params: any) => {
  try {
    const response = await postCall(urlConfig.ProcessStageInsertUpdate, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};
